"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const project_config_1 = __importStar(require("chaire-lib-common/lib/config/shared/project.config"));
const defaultVehiclesConfig = {
    maxCarsPerHouseholdMember: 3,
    maxBicyclesPerHouseholdMember: 3,
    maxTwoWheelsPerHouseholdMember: 3
};
// Make sure default values are set
const defaultConfig = {
    region: 'CA',
    logDatabaseUpdates: false,
    selfResponseMinimumAge: 14,
    interviewableAge: 5,
    adultAge: 18,
    drivingLicenseAge: 16,
    maxPersonAge: 125,
    addAuditWarningVeryOldAge: undefined,
    maxHouseholdSize: 18,
    vehicles: defaultVehiclesConfig,
    surveySupportForm: false,
    mapDefaultCenter: {
        lat: 45.5,
        lon: -73.6
    },
    countryCode: 'CA',
    startDateTimeWithTimezoneOffset: undefined,
    endDateTimeWithTimezoneOffset: undefined,
    surveyAreaGeojsonPath: undefined,
    hideStartButtonOnHomePage: false,
    introductionTwoParagraph: false,
    introBanner: false,
    bannerPaths: {},
    introLogoAfterStartButton: false,
    logoPaths: {},
    detectLanguageFromUrl: true,
    detectLanguage: false,
    languageNames: { en: 'English', fr: 'Français' },
    title: { en: 'Survey', fr: 'Enquête' },
    postalCodeRegion: 'other',
    hasAccessCode: false,
    personColorsPalette: [
        // FIXME See this issue https://github.com/chairemobilite/evolution/issues/1246
        '#FFAE70',
        '#FFBCF2',
        '#F2ED6A',
        '#90E04A',
        '#61CAD8',
        '#9F70FF',
        '#FF6868',
        '#63A021',
        '#21A09E',
        '#4146B5',
        '#9F41B5',
        '#B5417B',
        '#B5B5B5',
        '#B59900',
        '#9E5135',
        '#FFAE70',
        '#FFBCF2',
        '#F2ED6A',
        '#90E04A',
        '#61CAD8',
        '#9F70FF',
        '#FF6868',
        '#63A021',
        '#21A09E',
        '#4146B5',
        '#9F41B5',
        '#B5417B'
    ],
    requiredFieldsBySurveyObject: {
        interview: [],
        household: [],
        home: [],
        organization: [],
        vehicle: [],
        person: [],
        journey: [],
        tripChain: [],
        visitedPlace: [],
        trip: [],
        segment: [],
        junction: [],
        workPlace: [],
        schoolPlace: []
    },
    reviewableSurveyObjects: ['interview', 'home', 'household', 'person'],
    auditChecksGroup: 'custom', // custom by default so older surveys works.
    surveyBase: 'householdBased'
};
// Validate and set the configuration
const mergedConfig = Object.assign(Object.assign(Object.assign({}, defaultConfig), project_config_1.default), { vehicles: Object.assign(Object.assign({}, defaultVehiclesConfig), project_config_1.default.vehicles) });
(0, project_config_1.setProjectConfiguration)(mergedConfig);
exports.default = project_config_1.default;
//# sourceMappingURL=project.config.js.map